import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import Clinictransaction from "../clinic/ClinicTransaction";

export default function DoctorTransaction() {
  const navigate = useNavigate();
  const [canShowTransaction, setCanShowTransaction] = useState(
    localStorage.getItem("doctorShowTransaction") === "1"
  );

  useEffect(() => {
    fetch(window.API_PREFIX + "admin/doctordetail", {
      method: "POST",
      headers: {
        "Content-type": "application/json",
      },
      body: JSON.stringify({
        Token: localStorage.getItem("DToken"),
      }),
    })
      .then((resp) => resp.json())
      .then((data) => {
        if (data?.status === "Block") {
          toast.error(data?.message || "Unauthorized");
          localStorage.clear();
          navigate("/doctor");
          window.location.reload();
          return;
        }
        if (data?.status === "1") {
          const enabled = Number(data?.data?.ShowTransaction || 0) === 1;
          setCanShowTransaction(enabled);
          localStorage.setItem("doctorShowTransaction", enabled ? "1" : "0");
          if (!enabled) navigate("/doctor/dashboard");
        }
      });
  }, [navigate]);

  if (!canShowTransaction) return null;
  return <Clinictransaction />;
}

